import {QuoteForm} from "api/quote";
import {Form} from "pages/RateQuoteBind/RatePanel";
import HomeGeneralLiability from "./HomeGeneralLiability";
import UnderwritingForm from "../shared/UnderwritingForm";
import HomeLocationForm from "./HomeLocationForm";

export default function home(quoteForm: QuoteForm): Form {
  return {
    sections: {
      "Risk Location": (
        <HomeLocationForm
          locations={quoteForm.locations}
          quoteId={`${quoteForm.quote_id}`}
        />
      ),
      "General Liability": <HomeGeneralLiability home={quoteForm.home} />,
    },
    "Underwriting Questions": (
      <UnderwritingForm
        underwriting={quoteForm.underwriting}
        home={quoteForm.home}
      />
    ),
  };
}
